/**
 * 認証 + 共通レイアウトのルートラッパー
 *
 * React Router の layout route として使用し、ProtectedRoute と Layout を
 * 1 度だけマウントする。各ページが個別に <Layout> を呼ぶと、ナビゲーションの
 * たびにサイドバーがアンマウント／再マウントされてフリッカーが発生するため、
 * ここで一括ラップする。
 *
 * 使用例:
 *   <Route element={<LayoutRoute />}>
 *     <Route path="/home" element={<HomePage />} />
 *     ...
 *   </Route>
 */
import { Outlet } from "react-router-dom";
import Layout from "./Layout";
import ProtectedRoute from "./ProtectedRoute";

const LayoutRoute = () => (
    <ProtectedRoute>
        <Layout sidebarMode="always-expanded">
            <Outlet />
        </Layout>
    </ProtectedRoute>
);

export default LayoutRoute;
